export const buildImageUrl = (baseUrl, params = {}) => {
    if (!baseUrl)
        return '';
    const queryString = Object.entries(params)
        .filter(([_, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
    if (!queryString)
        return baseUrl;
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}${queryString}`;
};
//# sourceMappingURL=buildImageUrl.js.map